import { useEffect } from 'react';
import { isEqual } from 'lodash-es';
import { useTemplateVariables } from '~/components/AgreementStudioPage/TemplateVariables/TemplateVariablesContext';
export function PersistTemplateVariableValues(param) {
    let { setDraft } = param;
    const { templateVariableValues } = useTemplateVariables();
    useEffect(()=>{
        setDraft((prev)=>{
            var _prev_templateVariableValues;
            return isEqual((_prev_templateVariableValues = prev.templateVariableValues()) !== null && _prev_templateVariableValues !== void 0 ? _prev_templateVariableValues : {}, templateVariableValues) ? prev : prev.setTemplateVariableValues(templateVariableValues);
        });
    }, [
        templateVariableValues,
        setDraft
    ]);
    return null;
}
